import CardGrid from '@99designs/apps/spa/pages/create/components/CardGrid';
import React from 'react';
import { trackViewedDesignerEvent } from '@99designs/apps/spa/pages/create/events';
import DesignerCard from './DesignerCard';
import { useTransition, animated } from 'react-spring';
import { InviteDesignersPage_StructuredBriefFragment } from '@99designs/apps/spa/pages/create/components/InviteDesignersPage.generated';
import { DesignerCard_UserFragment } from '@99designs/apps/spa/pages/create/components/DesignerCard.generated';

interface Props {
    designers: Array<{ __typename: 'User' } & DesignerCard_UserFragment>;
    brief: InviteDesignersPage_StructuredBriefFragment;
}

function DesignerResultsGrid(props: Props) {
    const { brief, designers } = props;

    const relevantDesignerIds = designers.map((designer) => {
        return designer.id;
    });

    const transitions = useTransition(designers, (designer) => designer.id, {
        from: { transform: 'translateY(200px)', opacity: 0, display: 'flex', height: '100%' },
        enter: { transform: 'translateY(0)', opacity: 1 },
        trail: 100,
        config: { tension: 220, friction: 20 },
    });

    return (
        <CardGrid>
            {transitions.map(({ item: user, key, props }) => {
                const matchingLanguage = user.profile.locales.find((l) => l.tag === brief.language);
                return (
                    <animated.div style={props} key={key}>
                        <DesignerCard
                            user={user}
                            isSelected={brief.designers.some(({ id }) => id === user.id)}
                            position={relevantDesignerIds.indexOf(user.id)}
                            designerSource={'RECOMMENDED'}
                            onMount={() =>
                                trackViewedDesignerEvent({
                                    id: brief.id,
                                    designer_id: parseInt(user.id),
                                    designer_name: user.displayName,
                                    designer_level: user.profile.designerLevel,
                                    relevant_ranking: relevantDesignerIds.indexOf(user.id),
                                })
                            }
                            spokenLanguage={formattedLanguageTitleForLocale(matchingLanguage)}
                        />
                    </animated.div>
                );
            })}
        </CardGrid>
    );
}

function formattedLanguageTitleForLocale(language?: {
    tag: string;
    title: string;
}): string | undefined {
    if (!language) {
        return language;
    }

    switch (language.tag) {
        case 'en':
        case 'de':
        case 'pt':
            return language.title;
        case 'es':
        case 'fr':
        case 'it':
        case 'nl':
            return language.title.toLocaleLowerCase();
        default:
            return language.title;
    }
}

export default DesignerResultsGrid;
